import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import * as AppRoutingMatchers from './app-routing-matchers';
import { ReferrerResolver } from './base/resolvers/referrer.resolver';
import { PremiumSubCategories } from './catalog/products/subscription/plan/premium/sensation';
import { ProPremiumSubCategories } from './catalog/products/subscription/plan/pro/sensation';
import { ProSimoSubCategories } from './catalog/products/subscription/plan/pro/simo';
import { SimoSubCategories } from './catalog/products/subscription/plan/simo';

const appRoutes: Routes = [
    {
        path: '',
        resolve: { web: ReferrerResolver },
        data: {
            recallId: 'tlvctcmobile1',
            recallContext: 'ACQUISITION-GP',
        },
        children: [
            {
                path: 'offres-internet',
                loadChildren: () => import('@app/provider/provider.module').then((m) => m.ProviderModule),
            },
            {
                path: 'offres-internet-bbox-pro',
                loadChildren: () => import('@app/provider/provider-pro.module').then((m) => m.ProviderProModule),
            },
            {
                path: 'accessoires',
                data: {
                    categorie: 'accessory',
                },
                children: [
                    {
                        matcher: AppRoutingMatchers.filteredWallMatcher,
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                    {
                        path: ':id',
                        loadChildren: () =>
                            import('@app/modules/product-details/product-details.module').then(
                                (m) => m.ProductDetailsModule,
                            ),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                ],
            },
            {
                path: 'telephones-mobiles',
                data: { categorie: 'phone' },
                children: [
                    {
                        path: 'renouvellement',
                        loadChildren: () =>
                            import('app/modules/product-wall-renew/product-wall-renew.module').then(
                                (m) => m.ProductWallRenewModule,
                            ),
                    },
                    {
                        path: ':id',
                        loadChildren: () =>
                            import('@app/modules/product-details/product-details.module').then(
                                (m) => m.ProductDetailsModule,
                            ),
                    },
                ],
            },
            {
                path: 'telephones-mobiles-pro',
                data: { categorie: 'phone', type: 'pro' },
                children: [
                    {
                        matcher: AppRoutingMatchers.filteredWallMatcher,
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                    {
                        path: ':id',
                        loadChildren: () =>
                            import('@app/modules/product-details/product-details.module').then(
                                (m) => m.ProductDetailsModule,
                            ),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                ],
            },
            {
                path: 'bons-plans/soldes',
                data: { categorie: 'soldes' },
                children: [
                    {
                        matcher: AppRoutingMatchers.filteredWallMatcher,
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                    {
                        path: ':id',
                        loadChildren: () =>
                            import('@app/modules/product-details/product-details.module').then(
                                (m) => m.ProductDetailsModule,
                            ),
                    },
                    {
                        path: '',
                        data: { categorie: 'soldes' },
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                ],
            },
            {
                path: 'hotspot-tablette',
                data: { categorie: 'device_faim' },
                children: [
                    {
                        matcher: AppRoutingMatchers.filteredWallMatcher,
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                    {
                        path: ':id',
                        loadChildren: () =>
                            import('@app/modules/product-details/product-details.module').then(
                                (m) => m.ProductDetailsModule,
                            ),
                    },
                    {
                        path: '',
                        data: { categorie: 'device_faim' },
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                ],
            },
            {
                path: 'hotspot-tablette-pro',
                data: { categorie: 'device_faim', type: 'pro' },
                children: [
                    {
                        matcher: AppRoutingMatchers.filteredWallMatcher,
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                    {
                        path: ':id',
                        loadChildren: () =>
                            import('@app/modules/product-details/product-details.module').then(
                                (m) => m.ProductDetailsModule,
                            ),
                    },
                    {
                        path: '',
                        data: { categorie: 'device_faim' },
                        loadChildren: () =>
                            import('app/modules/product-wall/product-wall.module').then((m) => m.ProductWallModule),
                    },
                ],
            },
            {
                path: 'prise-interet',
                loadChildren: () =>
                    import('app/preeligibility/preeligibility.module').then((m) => m.PreeligibilityModule),
            },
            {
                path: 'comparateur',
                loadChildren: () => import('app/modules/comparator/comparator.module').then((m) => m.ComparatorModule),
            },
            {
                path: 'rappelez-moi',
                data: {
                    recallId: 'tlvctcautres1',
                },
                loadChildren: () => import('app/webcallback/webcallback.module').then((m) => m.WebcallbackModule),
            },
            {
                path: 'forfaits-mobiles',
                data: {
                    type: 'gp',
                    planTypes: [...SimoSubCategories, ...PremiumSubCategories],
                    recallContext: 'ACQUISITION-GP-FAM',
                },
                children: [
                    {
                        path: 'renouvellement',
                        data: {
                            recallContext: 'RENOUVELLEMENT-GP-FAM',
                        },
                        pathMatch: 'prefix',
                        loadChildren: () =>
                            import('app/catalog/category/plans-renew/plans-renew.module').then(
                                (m) => m.PlansRenewModule,
                            ),
                    },
                    {
                        path: 'avec-engagement',
                        pathMatch: 'prefix',
                        loadChildren: () => import('@app/modules/new-plans/plans.module').then((m) => m.PlansModule),
                    },
                    {
                        path: '',
                        pathMatch: 'prefix',
                        loadChildren: () =>
                            import('app/catalog/category/plans/plans.module').then((m) => m.PlansModule),
                    },
                ],
            },
            {
                path: 'forfaits-mobiles-pro',
                data: {
                    type: 'pro',
                    planTypes: [...ProSimoSubCategories, ...ProPremiumSubCategories],
                    recallContext: 'ACQUISITION-PRO-FAM',
                },
                children: [
                    {
                        path: 'renouvellement',
                        data: {
                            recallContext: 'RENOUVELLEMENT-PRO-FAM',
                        },
                        pathMatch: 'prefix',
                        loadChildren: () =>
                            import('app/catalog/category/plans-renew/plans-renew.module').then(
                                (m) => m.PlansRenewModule,
                            ),
                    },
                    {
                        path: 'avec-engagement',
                        loadChildren: () => import('@app/modules/new-plans/plans.module').then((m) => m.PlansModule),
                    },
                    {
                        path: 'sans-engagement',
                        redirectTo: 'avec-engagement',
                    },
                    {
                        path: '',
                        pathMatch: 'prefix',
                        loadChildren: () =>
                            import('app/catalog/category/plans/plans.module').then((m) => m.PlansModule),
                    },
                ],
            },
            {
                path: 'personnaliser-mon-offre',
                data: { categorie: 'cross-sell' },
                loadChildren: () => import('app/modules/cross-sell/cross-sell.module').then((m) => m.CrossSellModule),
            },
        ],
    },
    {
        path: '**',
        loadChildren: () =>
            import('app/modules/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            scrollPositionRestoration: 'top',
            paramsInheritanceStrategy: 'always',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
